<template>
  <v-toolbar
    elevation="3"
    color="white"
    :dense="this.$store.state.isRunningEmbedded"
    class="toolbar-content input-visible concierge-input"
    style="position: fixed; bottom: 0px; z-index: 1000;"
  >
    <div class="v-input v-input--horizontal v-input--density-compact v-theme--light v-locale--is-ltr v-text-field v-input--plain-underlined v-input v-input--horizontal v-input--density-compact v-theme--light v-locale--is-ltr v-text-field v-input--plain-underlined toolbar-text">
      <div class="v-input__control">
        <div class="v-field v-field--single-line v-field--no-label v-field--variant-underlined v-theme--light v-locale--is-ltr">
          <div class="v-field__overlay"></div>
          <div class="v-field__loader">
            <div class="v-progress-linear v-theme--light v-locale--is-ltr" role="progressbar" aria-hidden="true" aria-valuemin="0" aria-valuemax="100" style="top: 0px; height: 0px; --v-progress-linear-height: 2px;">
              <div class="v-progress-linear__background"></div>
              <div class="v-progress-linear__buffer" style="width: 0%;"></div>
              <div class="v-progress-linear__indeterminate">
                <div class="v-progress-linear__indeterminate long"></div>
                <div class="v-progress-linear__indeterminate short"></div>
              </div>
            </div>
          </div>
          <div class="v-field__field" data-no-activator="">
            <input name="text-input" size="1" type="text" id="text-input" aria-describedby="text-input-messages" class="v-field__input" value="" v-model="textInput" @keyup.enter.stop="postTextMessage" @focus="onTextFieldFocus" @blur="onTextFieldBlur" @update:model-value="onKeyUp" ref="textInput" :disabled="isLexProcessing">
          </div>
          <div class="v-field__outline"></div>
        </div>
      </div>
    </div>
    
    <div 
      data-v-d6017700="" 
      data-v-54f50400="" 
      class="v-row recorder-status bg-white" 
      style="display: none;">
      <div 
        data-v-d6017700="" 
        data-v-54f50400="" 
        class="status-text">
        <span 
          data-v-d6017700="" 
          data-v-54f50400="">Click on the mic</span>
      </div>
      <div 
        data-v-d6017700="" 
        data-v-54f50400="" 
        class="voice-controls ml-2"></div>
    </div>
    
    <!-- Mic button - shown when no text is entered -->
    <button 
      v-if="!textInput.length"
      type="button" 
      class="v-btn v-btn--icon v-theme--light v-btn--density-default v-btn--size-default v-btn--variant-text icon-color input-button" 
      @click="onMicClick" 
      v-on="tooltipEventHandlers" 
      :disabled="isMicButtonDisabled" 
      ref="mic"
    >
      <span class="v-btn__overlay"></span>
      <span class="v-btn__underlay"></span>
      <span class="v-btn__content" data-no-activator="">
        <i class="material-icons v-icon notranslate v-theme--light v-icon--size-x-large" aria-hidden="true">{{ micButtonIcon }}</i>
      </span>
    </button>

    <!-- Send button - shown when text is entered -->
    <button 
      v-if="textInput.length"
      type="button" 
      class="v-btn v-btn--icon v-theme--light v-btn--density-default v-btn--size-default v-btn--variant-text icon-color input-button send-button" 
      @click="postTextMessage" 
      :disabled="isLexProcessing || isSendButtonDisabled"
    >
      <span class="v-btn__overlay"></span>
      <span class="v-btn__underlay"></span>
      <span class="v-btn__content" data-no-activator="">
        <i class="material-icons v-icon notranslate v-theme--light v-icon--size-x-large" aria-hidden="true">send</i>
      </span>
    </button>
  </v-toolbar>
</template>

<script>
/*
Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.

Licensed under the Amazon Software License (the "License"). You may not use this file
except in compliance with the License. A copy of the License is located at

http://aws.amazon.com/asl/

or in the "license" file accompanying this file. This file is distributed on an "AS IS"
BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. See the
License for the specific language governing permissions and limitations under the License.
*/
/* eslint no-console: ["error", { allow: ["warn", "error"] }] */

export default {
  name: 'InputContainer',
  components: {
  },
  props: {
    textInputPlaceholder: {
      type: String,
      default: ''
    },
    initialSpeechInstruction: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      textInput: '',
      isTextFieldFocused: false,
      shouldShowTooltip: false,
      shouldShowAttachmentClear: false,
      // workaround: vuetify tooltips doesn't seem to support touch events
      tooltipEventHandlers: {
        mouseenter: this.onInputButtonHoverEnter,
        mouseleave: this.onInputButtonHoverLeave,
      },
    };
  },
  computed: {
    isBotSpeaking() {
      return this.$store.state.botAudio.isSpeaking;
    },
    isLexProcessing() {
      return this.$store.state.lex.isProcessing;
    },
    isSpeechConversationGoing() {
      return this.$store.state.recState.isConversationGoing;
    },
    isMicButtonDisabled() {
      return this.isMicMuted;
    },
    isMicMuted() {
      return this.$store.state.recState.isMicMuted;
    },
    isRecorderSupported() {
      return this.$store.state.recState.isRecorderSupported;
    },
    isRecorderEnabled() {
      return this.$store.state.recState.isRecorderEnabled;
    },
    isSendButtonDisabled() {
      return this.textInput.length < 1;
    },
    isModeLiveChat() {
      return this.$store.state.chatMode === 'livechat';
    },
    micButtonIcon() {
      if (this.isMicMuted) {
        return 'mic_off';
      }
      if (this.isBotSpeaking || this.isSpeechConversationGoing) {
        return 'stop';
      }
      return 'mic';
    },
    inputButtonTooltip() {
      if (this.shouldShowSendButton) {
        return 'send';
      }
      if (this.isMicMuted) {
        return 'mic seems to be muted';
      }
      if (this.isBotSpeaking || this.isSpeechConversationGoing) {
        return 'interrupt';
      }
      return 'click to use voice';
    },
    shouldShowSendButton() {
      return (
        (this.textInput.length && this.isTextFieldFocused) ||
        (!this.isRecorderSupported || !this.isRecorderEnabled) ||
        (this.isModeLiveChat)
      );
    },
    shouldShowTextInput() {
      return !(this.isBotSpeaking || this.isSpeechConversationGoing);
    },
    shouldShowUpload() {
      return (
        (this.$store.state.isLoggedIn && this.$store.state.config.ui.uploadRequireLogin && this.$store.state.config.ui.enableUpload) ||
        (!this.$store.state.config.ui.uploadRequireLogin && this.$store.state.config.ui.enableUpload)
      )
    },
  },
  methods: {
    onInputButtonHoverEnter() {
      this.shouldShowTooltip = true;
    },
    onInputButtonHoverLeave() {
      this.shouldShowTooltip = false;
    },
    onMicClick() {
      this.onInputButtonHoverLeave();
      
      // Toggle recorder status visibility
      const recorderStatus = document.querySelector('.recorder-status');
      if (recorderStatus) {
        const statusTextElement = recorderStatus.querySelector('.status-text span');
        
        if (this.isBotSpeaking || this.isSpeechConversationGoing) {
          recorderStatus.classList.remove('active');
          if (statusTextElement) {
            statusTextElement.textContent = 'Click on the mic';
          }
        } else if (!this.isSpeechConversationGoing) {
          recorderStatus.classList.add('active');
          // Use visibility:hidden instead of display:none to maintain layout
          const inputElement = document.querySelector('.v-input');
          if (inputElement) {
            inputElement.style.visibility = 'hidden';
          }
          if (statusTextElement) {
            statusTextElement.textContent = 'Listening...';
          }
        }
      }
      
      if (this.isBotSpeaking || this.isSpeechConversationGoing) {
        return this.$store.dispatch('interruptSpeechConversation');
      }
      if (!this.isSpeechConversationGoing) {
        return this.startSpeechConversation();
      }

      return Promise.resolve();
    },
    onTextFieldFocus() {
      this.isTextFieldFocused = true;
    },
    onTextFieldBlur() {
      if (!this.textInput.length && this.isTextFieldFocused) {
        this.isTextFieldFocused = false;
      }
    },
    onKeyUp() {
      this.$store.dispatch('sendTypingEvent');
    },
    setInputTextFieldFocus() {
      // focus() needs to be wrapped in setTimeout for IE11
      setTimeout(() => {
        if (this.$refs && this.$refs.textInput && this.shouldShowTextInput) {
          this.$refs.textInput.focus();
        }
      }, 10);
    },
    playInitialInstruction() {
      const isInitialState = ['', 'Fulfilled', 'Failed']
        .some(initialState => (
          this.$store.state.lex.dialogState === initialState
        ));

      return (isInitialState && this.initialSpeechInstruction.length > 0) ?
        this.$store.dispatch(
          'pollySynthesizeInitialSpeech'
        ) :
        Promise.resolve();
    },
    postTextMessage() {
      this.onInputButtonHoverLeave();
      this.textInput = this.textInput.trim();
      // empty string
      if (!this.textInput.length) {
        return Promise.resolve();
      }

      const message = {
        type: 'human',
        text: this.textInput,
      };

      // Add attachment filename to message
      if (this.$store.state.lex.sessionAttributes.userFilesUploaded) {
        const documents = JSON.parse(this.$store.state.lex.sessionAttributes.userFilesUploaded)

        message.attachements = documents
          .map(function(att) {
            return att.fileName;
          }).toString();
      }

      // If streaming, send session attributes for streaming
      if(this.$store.state.config.lex.allowStreamingResponses){
        // Replace with an HTTP endpoint for the fullfilment Lambda
        const streamingEndpoint = this.$store.state.config.lex.streamingWebSocketEndpoint.replace('wss://', 'https://');
        this.$store.dispatch('setSessionAttribute', 
          { key: 'streamingEndpoint', value: streamingEndpoint });
        this.$store.dispatch('setSessionAttribute', 
          { key: 'streamingDynamoDbTable', value: this.$store.state.config.lex.streamingDynamoDbTable });
      }

      return this.$store.dispatch('postTextMessage', message)
        .then(() => {
          this.textInput = '';
          if (this.shouldShowTextInput) {
            this.setInputTextFieldFocus();
          }
        });
    },
    startSpeechConversation() {
      if (this.isMicMuted) {
        return Promise.resolve();
      }
      return this.setAutoPlay()
        .then(() => this.playInitialInstruction())
        .then(() => {
            return new Promise(function(resolve, reject) {
              setTimeout(() => {
                resolve();
              }, 100)
            });
          })
        .then(() => this.$store.dispatch('startConversation'))
        .catch((error) => {
          console.error('error in startSpeechConversation', error);
          const errorMessage = (this.$store.state.config.ui.showErrorDetails) ?
            ` ${error}` : '';

          this.$store.dispatch(
            'pushErrorMessage',
            "Sorry, I couldn't start the conversation. Please try again." +
            `${errorMessage}`,
          );
        });
    },
    /**
     * Set auto-play attribute on audio element
     * On mobile, Audio nodes do not autoplay without user interaction.
     * To workaround that requirement, this plays a short silent audio mp3/ogg
     * as a reponse to a click. This silent audio is initialized as the src
     * of the audio node. Subsequent play on the same audio now
     * don't require interaction so this is only done once.
     */
    setAutoPlay() {
      if (this.$store.state.botAudio.autoPlay) {
        return Promise.resolve();
      }
      return this.$store.dispatch('setAudioAutoPlay');
    },
    onPickFile () {
      this.$refs.fileInput.click()
    },
    onFilePicked (event) {
      const files = event.target.files
      if (files[0] !== undefined) {
        this.fileName = files[0].name
        // Check validity of file
        if (this.fileName.lastIndexOf('.') <= 0) {
          return
        }
        // If valid, continue
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.fileObject = files[0] // this is an file that can be sent to server...
          this.$store.dispatch('uploadFile', this.fileObject);
          this.shouldShowAttachmentClear = true;
        })
      } else {
        this.fileName = '';
        this.fileObject = null;
      }
    },
    onRemoveAttachments() {
      delete this.$store.state.lex.sessionAttributes.userFilesUploaded;
      this.shouldShowAttachmentClear = false;
    },
    restoreInputDisplay() {
      // Restore input display when speech recognition ends
      const recorderStatus = document.querySelector('.recorder-status');
      if (recorderStatus) {
        recorderStatus.classList.remove('active');
        const inputElement = document.querySelector('.v-input');
        if (inputElement) {
          inputElement.style.visibility = 'visible';
        }
      }
    },
  },
  watch: {
    isSpeechConversationGoing(newVal, oldVal) {
      if (oldVal && !newVal) {
        // Speech conversation has ended
        this.restoreInputDisplay();
      }
    },
    isBotSpeaking(newVal, oldVal) {
      if (oldVal && !newVal) {
        // Bot stopped speaking
        this.restoreInputDisplay();
      }
    }
  },
};
</script>
<style>
.input-container {
  /* make footer same height as dense toolbar */
  min-height: 48px;
  position: fixed;
  bottom: 0;
  bottom: env(safe-area-inset-bottom);
  left: 0;
  left: env(safe-area-inset-left);
  right: 0;
  right: env(safe-area-inset-right);
  background-color: white;
  border-top: 1px solid rgba(52, 152, 219, 0.1);
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  z-index: 1000;
}

.toolbar-content {
  padding: 10px 16px;
  font-size: 16px !important;
  background: white !important;
  box-shadow: none !important;
  border-radius: 0;
  display: flex;
  align-items: center;
}

.v-input {
  margin-bottom: 0;
  font-family: 'Roboto', sans-serif;
  flex: 1;
}

.v-field__input:disabled {
  background-color: #f5f5f5 !important;
  color: #9e9e9e !important;
  cursor: not-allowed !important;
  opacity: 0.6 !important;
}

.toolbar-text {
  font-size: 1rem;
  padding: 0 12px;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.input-button {
  margin-left: 8px;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) !important;
  border-radius: 50% !important;
  width: 40px !important;
  height: 40px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  position: relative;
  overflow: hidden;
  position: relative;
  z-index: 3;
}

.input-visible {
  display: flex !important;
}

.concierge-input {
  width: 100%;
}

.send-button {
  background: linear-gradient(135deg, #3498db, #2980b9) !important;
  color: white !important;
}

.send-button:hover {
  transform: translateY(-2px) scale(1.05);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2) !important;
  background: linear-gradient(135deg, #2980b9, #1c638e) !important;
}

.mic-button, .upload-button, .clear-button {
  color: #5f6368 !important;
  background: linear-gradient(135deg, #f8f9fa, #f1f3f4) !important;
  border: 1px solid rgba(0, 0, 0, 0.05) !important;
}

.mic-button:hover, .upload-button:hover, .clear-button:hover {
  transform: translateY(-2px) scale(1.05);
  background: linear-gradient(135deg, #f1f3f4, #e8eaed) !important;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;
}

.icon-color {
  color: inherit;
}

.v-icon {
  font-size: 20px !important;
  transition: all 0.3s ease;
}

.recorder-status {
  display: none;
  position: absolute;
  width: 100%;
  left: 0;
  padding: 0 16px;
}

.recorder-status.active {
  display: flex;
  z-index: 2;
}

/* Fix for progress linear components */
.v-progress-linear__indeterminate .long, 
.v-progress-linear__indeterminate .short {
  animation-play-state: running;
  left: auto;
}
</style>
